export default __webpack_public_path__ + "static/media/iconsRWB.846ceac1.png";